import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const productsSchema: CollectionCreateSchema = {
  name: CollectionName.Products,
  fields: [
    {
      name: "party_id",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "search_id",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "package",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "product_number",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "commodity",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "description",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "last_modified",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "exporter_reference",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "wine_colour",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    // DFE expects this to be CS or FT
    {
      name: "wine_shipping_format",
      type: "string",
      optional: true,
      // infix: true,
    },
    {
      name: "wine_shipping_format_description",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
      facet: true,
    },
    {
      name: "eligible_markets",
      type: "string[]",
      optional: true,
      facet: true,
      infix: true,
    },
    {
      name: "accessible_by",
      type: "string[]",
      optional: false,
      infix: true,
    },
    {
      name: "organisation",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Private,
}
